<mat-dialog-content class="login-dialog-content">
    <h2 matDialogTitle>Get a Magic Link</h2>
    @if( !linkSent ) {
    <div class="login-content-container">
        <div class="login-content">
            <p class="help-text">Enter your email and we'll send you a magic link to login.</p>
            <form [formGroup]="loginFormGroup">
                <mat-form-field>
                    <mat-label>Your Email</mat-label>
                    <input matInput placeholder="Email" formControlName="email">
                </mat-form-field>
                <button mat-flat-button (click)="onSubmit()" color="primary">Send Link</button>
            </form>
        </div>
    </div>
    } @else {
    <div class="login-content-container">
        <div class="login-content">
            <p>Check your email for a magic link to login.</p>
            <p>If you don't see it, check your spam folder.</p>

        </div>
    </div>
    }

</mat-dialog-content>
@if( linkSent ) {
<mat-dialog-actions>
    <button class="ok-button" matButton="filled" (click)="onOkClick()" cdkFocusInitial>OK</button>
</mat-dialog-actions>
}